<template>
    <div class="filter-actions">
        <el-button @click="downloadCSV">Download CSV</el-button>
    </div>
</template>

<script setup>
import { defineProps } from "vue";
import { useUrlFilters } from "../../composables/useUrlFilters";
import { saveTextAsFile } from "../../helpers/saveTextasFile";
import { getCustomersCSV } from "../../api/rest";

const props = defineProps({
    locations: {
        type: Array,
        default: () => [],
    },
    experiences: {
        type: Array,
        default: () => [],
    },
});

const filterStore = useUrlFilters(
    () => props.locations,
    () => props.experiences,
);

const downloadCSV = async () => {
    const filter = { ...filterStore.filters.value, limit: undefined };
    const result = await getCustomersCSV(filter);
    saveTextAsFile(result, "customer_data.csv", "csv");
};
</script>

<style scoped lang="scss">
@use "../../colors" as *;

.filter-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 1rem;
    padding: 0.5rem;
    background-color: rgba($color-background, 0.71);
    border: 1px solid $color-primary;
    border-radius: 0.5rem;
}
</style>
